import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CMSService } from '../../../services/cms-service';
import { Personnel } from 'model/modal-cms/personnel';
import Swal from 'sweetalert2'
import { Rapports } from 'model/modal-cms/rapport_activite';
import { environment } from 'environments/environment';
import { HttpClient } from '@angular/common/http';
import { AdminService } from '../../../services/admin';


declare var mdtoast: any;
var success_message = mdtoast('Opération effectué avec succès.', { duration: 5000, init: true, type: mdtoast.SUCCESS });
var error_message = mdtoast('Opération non effectué.', { duration: 5000, init: true, type: mdtoast.ERROR });
var info_message = mdtoast('Opération non effectué. Ce donnée est en cours d\'utilisation.', { duration: 5000, init: true, type: mdtoast.INFO });


@Component({
  selector: 'app-rapport-activiter-medecin',
  templateUrl: './rapport-activiter-medecin.component.html',
  styleUrls: ['./rapport-activiter-medecin.component.scss']
})
export class RapportActiviterMedecinComponent implements OnInit {
id:any;
personnel : Personnel=new Personnel(null);
rapports : Rapports=new Rapports(null);
fileToUmpload: File = null;
urlServer = environment.urlServerphoto;
mode_ajout:any;
imageUrl:any
rambony:any =  "MANUEL_D_UTILISATION%20Site%20CMS.pdf";
loginuserCMSActuel:any;
rapports_act: any;

  constructor(public activatedRoute: ActivatedRoute,public cmsService: CMSService,public adminService: AdminService, private http: HttpClient,) { 
    this.id = activatedRoute.snapshot.params['id'];
    
  }


  ngOnInit() {
    this.getListeMed();
    this.getRapportActivite();
  }

  getListeMed() {
    this.cmsService.getInfoMed(this.id)
      .subscribe(data => {
        this.personnel = data
      },
        err => {
          console.log(err);
        })

  }


  getRapportActivite() {
    this.cmsService.getRaportActivitebyIM(this.id)
      .subscribe(data => {
        this.rapports_act = data
      },
        err => {
          console.log(err);
        })
  }

  getInfoRapportMed(id_rap:number) {
    this.cmsService.getInfoRapportMed(id_rap)
      .subscribe(data => {
        this.rapports = data
      },
        err => {
          console.log(err);
        })

  }

  getInfoRapportMed_(id_rap:number) {
    this.cmsService.getInfoRapportMed(id_rap)
      .subscribe(data => {
        this.rapports = data
        Swal.fire({
        title: 'Rapports d\'actictivité' ,
        icon: 'info',
        text: 'Rapports d\'actictivité du médecin.',
        showCancelButton: true,
        confirmButtonText: 'Oui, Voir!',
        cancelButtonText: 'Non'
      }).then((result) => {
        if (result.value) {
          
         
        } else if (result.dismiss === Swal.DismissReason.cancel) {
        //cancel btn
        }
      });
      },
        err => {
          console.log(err);
        })

  }



   //upload  file MED
    onChangeSelectFile(file: FileList) {
      this.fileToUmpload = file.item(0);
      console.log(this.fileToUmpload);
      var reader = new FileReader();
      reader.onload = (event: any) => {
        this.imageUrl = event.target.result;
      }
      reader.readAsDataURL(this.fileToUmpload);
    }

     //uplod logo IEC
   enregistrerFileMed() {   
    const uploadData = new FormData();
    uploadData.append('avatar', this.fileToUmpload, this.fileToUmpload.name);
    this.http.post(this.urlServer +'uploadFichierRapMed.php', uploadData, {
      reportProgress: true,
      observe: 'events'
    })
      .subscribe(event => {
        console.log(event);
      }
      )
  }



  SaveRapportMed(){
    if (this.rapports.id_rap == null) {
      this.rapports.mat_pers = this.id; 
            if(this.fileToUmpload==null){
                 this.rapports.document = "undefind";
              }else{
              this.rapports.document = this.fileToUmpload.name
              }
     
      console.log(this.rapports);
      this.cmsService.saveRaport(this.rapports).subscribe(data=>{
        if(data.err){
           //toastr.error(data.err);return;
         }   
           //toastr.error(data.err);return;
          
           if(this.fileToUmpload!=null){
                  this.enregistrerFileMed();
              }
           this.getRapportActivite();
           this.rapports = new Rapports(null)
           success_message.show();
         },err=>{ 
          error_message.show();    
         })
    }else{ if(this.fileToUmpload==null)  {
       
         }else{
           this.rapports.document = this.fileToUmpload.name
           this.enregistrerFileMed();
         }
      this.cmsService.updateRaport(this.rapports).subscribe(data=>{
        if(data.err){
           //toastr.error(data.err);return;
         }   
           //toastr.error(data.err);return;
           this.getRapportActivite();
           this.rapports = new Rapports(null)
           success_message.show();
         },err=>{ 
          error_message.show();    
         })
    }
    
  }


  deleteRapports(r: Rapports) {
    Swal.fire({
      title: 'Êtes-vous sûr de supprimer?',
      text: "Une fois que vous cliquez sur Ok, vous ne pouvez plus revenir en arrière.",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'OK',
      cancelButtonText: 'Non'
    }).then((result) => {
      if (result.value) {
        this.cmsService.deleteRaport(r.id_rap)
        .subscribe(data => {
          this.getRapportActivite();
          success_message.show();
        }, err => {
          console.log('erreur de supression');
        })
      }
    })
 }



}
